module.exports = __webpack_public_path__ + "static/media/microscope.9bc1cdd9.png";